import { CI_PORT_QUERY_KEY } from 'reservations/base/constants/bentobox';
import { getDevRoot } from 'reservations/base/constants/endpoints';
import { NodeEnv } from 'reservations/base/constants/environments';

function buildBentoboxApiEndpoint(
  endpoint: string,
  queryParams?: Record<string, any>
): string {
  let formattedEndpoint = endpoint;
  if (process.env.NODE_ENV !== NodeEnv.PRODUCTION) {
    if (formattedEndpoint.includes('https')) {
      formattedEndpoint = formattedEndpoint.replace('8080', '8000');
    } else {
      formattedEndpoint = `${getDevRoot()}${formattedEndpoint}`;
    }

    // To support integration tests, ci-port query string will be included on the new URL.
    const params = new URLSearchParams(window.location.search);
    if (params.has(CI_PORT_QUERY_KEY)) {
      let ciPort = params.get(CI_PORT_QUERY_KEY);
      formattedEndpoint = formattedEndpoint.replace('8000', `${ciPort}`);
    }
  }

  if (queryParams) {
    const queryParamString = buildQueryParamString(queryParams);
    formattedEndpoint = `${formattedEndpoint}?${queryParamString}`;
  }

  return formattedEndpoint;
}

function buildBentoboxApiEndpointForNode(
  endpoint: string,
  additionalContext: { host: string; query: { [CI_PORT_QUERY_KEY]?: string } }
): string {
  let formattedEndpoint = `https://${additionalContext.host}${endpoint}`;

  if (process.env.NODE_ENV !== NodeEnv.PRODUCTION) {
    const devRoot = `https://${additionalContext.host.split('.')[0]}.localtest.me:8000`;
    formattedEndpoint = `${devRoot}${endpoint}`;

    const query = additionalContext.query;
    if (CI_PORT_QUERY_KEY in query) {
      let ciPort = query[CI_PORT_QUERY_KEY];
      formattedEndpoint = formattedEndpoint.replace('8000', `${ciPort}`);
    }
  }

  return formattedEndpoint;
}

function buildQueryParamString(
  queryParams: Record<string, string | number | null | undefined>
): string {
  return Object.entries(queryParams).reduce((acc, [key, value]) => {
    if (value == null || value === '') {
      return acc;
    }

    if (acc === '') {
      return `${key}=${value}`;
    }

    return `${acc}&${key}=${value}`;
  }, '');
}

export {
  buildBentoboxApiEndpoint,
  buildQueryParamString,
  buildBentoboxApiEndpointForNode
};
